export default __webpack_public_path__ + "static/media/caps02.46ecf2f6.gif";